module.exports = __webpack_public_path__ + "img/logo.b9bcc8b9.png";